<template>
  <div v-loading="loading">
    <FormBox
      :title="
        applicationType == 'FIRST'
          ? $t('message.DataRegistration.formData.drivers_data')
          : $t('message.DataRegistration.Driver.update_drivers_data')
      "
      style="background: #fff"
    >
      <div
        v-if="
          $store.state.serviceType == 'HZMB_FIRST_PERSON' ||
          $store.state.serviceType == 'HZMB_RENEW_PERSON'
        "
        class="input_choose"
      >
        <div class="input_choose_title">
          {{
            applicationType == "FIRST"
              ? $t("message.DataRegistration.formData.input_drivers")
              : $t("message.DataRegistration.Driver.no_update_tips")
          }}
        </div>
        <div v-if="applicationType == 'FIRST'" class="input_choose_btns">
          <!-- <el-button
            v-if="quotaPersonAge >= 70"
            type="primary"
            plain
            @click="setDrivers(0)"
            :disabled="locked == 0"
          >{{$t('message.DataRegistration.formData.nothing')}}</el-button>-->
          <el-radio-group v-model="setDriver" @change="quotaChange">
            <el-radio v-if="quotaPersonAge >= 70" :label="0" border>{{
              $t("message.DataRegistration.formData.nothing")
            }}</el-radio>
            <el-radio
              v-for="(item, index) in [{}]"
              :key="index"
              :label="index + 1"
              border
              >{{ driversNum(index, false) }}</el-radio
            >
          </el-radio-group>
          <!-- <el-button
            v-for="(item,index) in form.drivers"
            :key="index"
            type="primary"
            plain
            @click="setDrivers(index + 1)"
          >{{driversNum(index,false)}}</el-button>-->
        </div>
      </div>
      <div v-for="(item, index) in form.drivers" :key="index">
        <FormCard
          :title="driversNum(index, false)"
          @close="closeCard(index)"
          :showClose="applicationType == 'RENEW' || form.drivers.length != 1"
        >
          <el-form
            ref="ruleForm"
            :model="form.drivers[index]"
            class="form_box"
            :rules="driversRules"
            hide-required-asterisk
          >
            <el-row :gutter="86">
              <!-- 第一駕駛員的中文姓名 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.nameCn'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="nameCn"
                >
                  <el-input
                    v-model="form.drivers[index].nameCn"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.DataRegistration.Driver.nameCn_plh')
                    "
                    :disabled="locked == index + 1"
                    @input="inputToUpperCase($event, index, 'nameCn')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的外文姓名 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.nameEn'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="nameEn"
                >
                  <el-input
                    v-model="form.drivers[index].nameEn"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.DataRegistration.Driver.nameEn_plh')
                    "
                    :disabled="locked == index + 1"
                    @input="inputToUpperCase($event, index, 'nameEn')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="86">
              <!-- 第一駕駛員的澳門居民身份證編號 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.identityNo'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="identityNo"
                  :disabled="locked == index + 1"
                >
                  <el-input
                    v-model.trim="form.drivers[index].identityNo"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.DataRegistration.Driver.identityNo_plh')
                    "
                    :disabled="locked == index + 1"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的出生日期 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.birthday'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="birthday"
                >
                  <el-date-picker
                    v-model="form.drivers[index].birthday"
                    type="date"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.DataRegistration.Driver.birthday_plh')
                    "
                    :picker-options="beforeToday"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    :disabled="locked == index + 1"
                    @change="changeBirthday($event, index)"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="86">
              <!-- 第一駕駛員的性別 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.sex'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="sex"
                >
                  <el-select
                    v-model="form.drivers[index].sex"
                    :placeholder="$t('message.DataRegistration.Driver.sex_plh')"
                    value-key="codeKey"
                  >
                    <el-option
                      v-for="item in sex"
                      :key="item.codeKey"
                      :label="item[`${$t('message.codeName')}`]"
                      :value="item.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的國籍 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.nationality'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="nationality"
                >
                  <el-select
                    v-model="form.drivers[index].nationality"
                    value-key="codeKey"
                    filterable
                    :placeholder="
                      $t('message.DataRegistration.Driver.nationality_plh')
                    "
                    @change="changeNationality($event, index)"
                  >
                    <el-option
                      v-for="nation in nationality"
                      :key="nation.codeKey"
                      :label="nation[`${$t('message.codeName')}`]"
                      :value="nation.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第一駕駛員的其他國籍 -->
            <el-row :gutter="86">
              <el-col
                v-if="form.drivers[index].otherNationality"
                :xs="24"
                :sm="24"
              >
                <el-row :gutter="86">
                  <el-col :xs="24" :sm="12" style="float: right; clear: both">
                    <el-form-item
                      v-if="applicationType == 'FIRST'"
                      :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                        'message.DataRegistration.Driver.other_nationality'
                      )}${lan == 'PT' ? driversNum(index) : ''}`"
                      prop="otherNationalityText"
                    >
                      <el-input
                        v-model="form.drivers[index].otherNationalityText"
                        :placeholder="
                          $t(
                            'message.DataRegistration.Driver.other_nationality_plh'
                          )
                        "
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="86">
              <!-- 第一駕駛員的澳門駕駛文件類別 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.macauDrivingLicenseType'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="macauDrivingLicenseType"
                >
                  <el-select
                    filterable
                    v-model="form.drivers[index].macauDrivingLicenseType"
                    :placeholder="
                      $t(
                        'message.DataRegistration.Driver.macauDrivingLicenseType_plh'
                      )
                    "
                    value-key="codeKey"
                  >
                    <el-option
                      v-for="item in drivingLicenseType"
                      :key="item.codeKey"
                      :label="item[`${$t('message.codeName')}`]"
                      :value="item.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的澳門駕駛文件編號 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.macauDrivingLicenseNo'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="macauDrivingLicenseNo"
                >
                  <el-input
                    v-model.trim="form.drivers[index].macauDrivingLicenseNo"
                    :placeholder="
                      $t(
                        'message.DataRegistration.Driver.macauDrivingLicenseNo_plh'
                      )
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第一駕駛員的本澳流動電話 -->
            <el-row :gutter="86">
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.macauMobile'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="macauMobile"
                >
                  <el-input
                    v-model="form.drivers[index].macauMobile"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.DataRegistration.Driver.macauMobile_plh')
                    "
                    :disabled="locked == index + 1"
                    maxlength="8"
                  >
                    <template slot="prepend">+853</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- macauAddress -->
            <!-- 第一駕駛員的澳門聯絡地址 -->
            <el-row :gutter="86">
              <el-col :span="24">
                <el-form-item
                  v-if="applicationType == 'FIRST'"
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.macauAddress.macauAddress'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="macauAddress.textCn"
                >
                  <el-input
                    v-if="form.drivers[index].macauAddress.textPt"
                    ref="macauAddressInput"
                    v-model="form.drivers[index].macauAddress.textPt"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.macauAddress.macauAddress_plh')
                    "
                    :disabled="locked == index + 1"
                    @focus="onAddressFocus(index)"
                  ></el-input>
                  <el-input
                    v-else
                    ref="macauAddressInput"
                    v-model="form.drivers[index].macauAddress.textCn"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('message.macauAddress.macauAddress_plh')
                    "
                    :disabled="locked == index + 1"
                    @focus="onAddressFocus(index)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="86">
              <!-- 第一駕駛員的內地聯絡電話 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.mainlandPhone'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="mainlandPhone"
                >
                  <el-input
                    v-model="form.drivers[index].mainlandPhone"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t(
                            'message.DataRegistration.Driver.mainlandPhone_plh'
                          )
                    "
                    :disabled="locked == index + 1"
                    maxlength="11"
                  >
                    <template slot="prepend">+86</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的內地電郵地址 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.mainlandEmail'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="mainlandEmail"
                >
                  <el-input
                    v-model="form.drivers[index].mainlandEmail"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t(
                            'message.DataRegistration.Driver.mainlandEmail_plh'
                          )
                    "
                    :disabled="locked == index + 1"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="86">
              <!-- 選填提示 -->
              <el-col :xs="24" :sm="24">
                <div :class="`tips_red tips_red_${$i18n.locale}`">
                  {{
                    $t(
                      "message.formRuleMessage.either_or_mainlandPhone_mainlandEmail_drivers"
                    )
                  }}
                </div>
              </el-col>
            </el-row>
            <el-row
              v-if="ageCalculation(form.drivers[index].birthday) >= 70"
              :gutter="86"
            >
              <!-- 第一駕駛員的內地駕照編號 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.mainlandDrivingLicenseNo'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="mainlandDrivingLicenseNo"
                >
                  <slot name="label">
                    <i
                      class="el-icon-warning-outline warn-icon"
                      @click="showLicenseNoTipsDialog = true"
                    ></i>
                  </slot>
                  <el-input
                    v-model="form.drivers[index].mainlandDrivingLicenseNo"
                    :placeholder="
                      $t(
                        'message.DataRegistration.Driver.mainlandDrivingLicenseNo_plh'
                      )
                    "
                  ></el-input>
                  <el-dialog
                    :visible.sync="showLicenseNoTipsDialog"
                    :title="$t('message.redCircleTips')"
                    width="370px"
                    :close-on-click-modal="false"
                  >
                    <img
                      src="../../../../assets/mainlandDrivingLicenseNo_tips.png"
                    />
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="showLicenseNoTipsDialog = false">{{
                        $t("message.close")
                      }}</el-button>
                    </span>
                  </el-dialog>
                </el-form-item>
              </el-col>
              <!-- 第一駕駛員的內地駕駛許可檔案編號 -->
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="`${lan != 'PT' ? driversNum(index) : ''}${$t(
                    'message.DataRegistration.Driver.mainlandDrivingPermitNo'
                  )}${lan == 'PT' ? driversNum(index) : ''}`"
                  prop="mainlandDrivingPermitNo"
                >
                  <slot name="label">
                    <i
                      class="el-icon-warning-outline warn-icon"
                      @click="showPermitNoTipsDialog = true"
                    ></i>
                  </slot>
                  <el-input
                    v-model="form.drivers[index].mainlandDrivingPermitNo"
                    :placeholder="
                      $t(
                        'message.DataRegistration.Driver.mainlandDrivingPermitNo_plh'
                      )
                    "
                  ></el-input>
                  <el-dialog
                    :visible.sync="showPermitNoTipsDialog"
                    :title="$t('message.redCircleTips')"
                    width="370px"
                    :close-on-click-modal="false"
                  >
                    <img
                      src="../../../../assets/mainlandDrivingPermitNo_tips.png"
                    />
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="showPermitNoTipsDialog = false">{{
                        $t("message.close")
                      }}</el-button>
                    </span>
                  </el-dialog>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </FormCard>
      </div>
      <!-- 新增駕駛員按鈕 -->
      <div v-if="applicationType == 'FIRST'" class="add_driver">
        <GradientBtn :disabled="form.drivers.length == 3" @click="addCard">{{
          $t("message.DataRegistration.formData.add_drivers")
        }}</GradientBtn>
      </div>
    </FormBox>

    <!-- 澳門地址彈窗 -->
    <MacauAddressDialog
      :visible="showAddressDialog"
      @save="saveMacauAddress"
      @close="showAddressDialog = false"
    ></MacauAddressDialog>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "./FormBox";
import FormCard from "./FormCard";
import VssViewAPI from "../../../../api/VssViewAPI";
import MacauAddressDialog from "./MacauAddressDialog";
import GradientBtn from "../../../../components/GradientBtn";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          drivers: [
            {
              macauAddress: {},
            },
          ],
        };
      },
    },
    applicationType: String,
  },
  components: { FormBox, FormCard, MacauAddressDialog, GradientBtn },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    };
    let olderThan18 = (rule, value, callback) => {
      const birthdays = new Date(value) || value;
      let d = new Date();
      let age = null;
      if (birthdays) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      if (value && age < 18) {
        callback(new Error(i18n.t("message.formRuleMessage.olderThan18")));
      } else {
        callback();
      }
    };
    let macauDrivingLicenseCheck = (rule, value, callback) => {
      // console.log(rule);
      // 通過是否有重複項判斷是否重複
      const isRepeat = (arr) => {
        var hash = {};
        for (var i in arr) {
          if (hash[arr[i]]) {
            return true;
          }
          hash[arr[i]] = true;
        }
        return false;
      };

      if (value) {
        var drivers = this.form.drivers.map((item) => {
          return item.macauDrivingLicenseType && item.macauDrivingLicenseNo
            ? item.macauDrivingLicenseType + item.macauDrivingLicenseNo
            : null;
        });
        if (isRepeat(drivers)) {
          callback(
            new Error(
              i18n.t("message.formRuleMessage.macauDrivingLicenseCheck")
            )
          );
        } else {
          for (let i in this.$refs["ruleForm"]) {
            let _field = this.$refs["ruleForm"][i].fields;
            // console.log(this.$refs["ruleForm"][i].fields);
            _field.map((i) => {
              if (
                i.prop === "macauDrivingLicenseNo" ||
                i.prop === "macauDrivingLicenseType"
              ) {
                i.clearValidate();
                return false;
              }
            });
          }
          callback();
        }
      }
    };
    let mainlandPhoneCheck = (rule, value, callback) => {
      // 驗證內地聯絡電話
      for (let i in this.form.drivers) {
        let mainlandPhone = this.form.drivers[i].mainlandPhone;
        let mainlandEmail = this.form.drivers[i].mainlandEmail;
        if (value == mainlandPhone && !mainlandEmail) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = false;
        }
        if (value == mainlandPhone && !value && !mainlandEmail) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = true;
          callback(new Error(""));
        } else {
          callback();
        }
      }
      // const mainlandEmail = this.form.quota.mainlandEmail || null;
      // if (value && !mainlandEmail) {
      //   this.driversRules.mainlandPhone[0].required = true;
      //   this.driversRules.mainlandEmail[0].required = false;
      //   // this.$refs["ruleForm"].validateField("mainlandEmail");
      // }
      // if (!value && !mainlandEmail) {
      //   this.driversRules.mainlandPhone[0].required = true;
      //   this.driversRules.mainlandEmail[0].required = true;
      //   callback(new Error(""));
      // } else {
      //   callback();
      // }
    };
    let mainlandEmailCheck = (rule, value, callback) => {
      //验证邮箱地址
      // const mainlandPhone = this.form.quota.mainlandPhone || null;
      const patt = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (value && !patt.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.email")));
        return;
      }
      for (let i in this.form.drivers) {
        let mainlandPhone = this.form.drivers[i].mainlandPhone;
        let mainlandEmail = this.form.drivers[i].mainlandEmail;
        if (value == mainlandEmail && !mainlandPhone) {
          this.driversRules.mainlandPhone[0].required = false;
          this.driversRules.mainlandEmail[0].required = true;
        }
        if (value == mainlandEmail && !value && !mainlandPhone) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = true;
          callback(new Error(""));
        } else {
          callback();
        }
      }
      // if (value && !mainlandPhone) {
      //   this.driversRules.mainlandPhone[0].required = false;
      //   this.driversRules.mainlandEmail[0].required = true;
      //   this.$refs["ruleForm"].validateField("mainlandPhone");
      // }
      // if (!value && !mainlandPhone) {
      //   this.driversRules.mainlandPhone[0].required = true;
      //   this.driversRules.mainlandEmail[0].required = true;
      //   callback(new Error(""));
      // } else {
      //   callback();
      // }
    };
    return {
      loading: false,
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      olderThan18: {
        disabledDate(time) {
          const older18 = new Date().setYear(new Date().getFullYear() - 18);
          return time.getTime() > older18;
        },
      },
      driversRules: {
        nameCn: [
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
        ],
        nameEn: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 200,
            message: i18n.t("message.formRuleMessage.maxLength200"),
            trigger: "blur",
          },
        ],
        identityNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        birthday: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.changeDate"),
            trigger: "blur",
          },
          { validator: olderThan18, trigger: "change" },
          { validator: olderThan18, trigger: "blur" },
        ],
        nationality: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
        ],
        otherNationalityText: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        macauDrivingLicenseType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          { validator: macauDrivingLicenseCheck, trigger: "submit" },
        ],
        macauDrivingLicenseNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
          { validator: macauDrivingLicenseCheck, trigger: "submit" },
        ],
        mainlandEmail: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
          { validator: mainlandEmailCheck },
        ],
        macauMobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
          {
            max: 30,
            message: i18n.t("message.formRuleMessage.maxLength30"),
            trigger: "blur",
          },
        ],
        mainlandPhone: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            pattern: /^[\d]+$/,
            message: i18n.t("message.formRuleMessage.mainlandPhone"),
            trigger: "blur",
          },
          { validator: mainlandPhoneCheck },
        ],
        mainlandDrivingLicenseNo: [
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        mainlandDrivingPermitNo: [
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        "macauAddress.textCn": [
          {
            required: true,
            message: i18n.t("message.macauAddress.macauAddress_plh"),
          },
        ],
      },
      macauAddress: [
        {
          label: "可選示範澳門地址一澳門馬揸度博士大馬路221-279號先進廣場大廈",
          code: "macauAddress1",
        },
      ],
      sex: [],
      nationality: [],
      drivingLicenseType: [],
      locked: null,
      setDriver: "",
      setDriverOld: null,
      timer: "",
      showAddressDialog: false,
      macauAddressIndex: -1,
      showLicenseNoTipsDialog: false,
      showPermitNoTipsDialog: false,
    };
  },
  watch: {
    "form.quota": {
      handler(newName, oldName) {
        clearTimeout(this.timer);
        if (this.locked) {
          this.timer = setTimeout(() => {
            this.setDrivers(this.locked, true);
          }, 1000);
        }
      },
      immediate: true,
      deep: true,
    },
    quotaPersonAge(val) {
      if (val < 70) {
        this.locked = 1;
        this.setDrivers(1, true);
      }
    },
    setDriver(newVal, oldVal) {
      this.setDriverOld = oldVal;
    },
  },
  computed: {
    driversNum() {
      return function (index, showDe = true) {
        if (showDe) {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver_de")
          );
        } else {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver")
          );
        }
      };
    },

    quotaPersonAge() {
      const birthday = this.form.quota.personBirthday;
      return this.ageCalculation(birthday);
    },
    ageCalculation() {
      return (birthday) => {
        const birthdays = new Date(birthday);
        let d = new Date();
        let age = null;
        if (birthday) {
          age =
            d.getFullYear() -
            birthdays.getFullYear() -
            (d.getMonth() < birthdays.getMonth() ||
            (d.getMonth() == birthdays.getMonth() &&
              d.getDate() < birthdays.getDate())
              ? 1
              : 0);
        }
        return age || 0;
      };
    },
    lan() {
      return this.$i18n.locale;
    },
  },
  methods: {
    //   删除卡片式表单
    closeCard(index) {
      let drivers = this.form.drivers;
      delete drivers[index];
      this.form.drivers = drivers.filter((item) => item);
    },
    //   增加卡片式表单
    addCard() {
      this.form.drivers.push({
        macauAddress: {
          textCn: "",
          textPt: "",
        },
      });
    },

    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = true;
      if (this.form.drivers.length < 1) return true;
      delete this.driversRules.macauDrivingLicenseType[1].trigger;
      delete this.driversRules.macauDrivingLicenseNo[2].trigger;
      for (let i = 0; i < this.form.drivers.length; i++) {
        let drivers = this.form.drivers;
        console.log(
          drivers.filter((item) => !item.mainlandPhone && !item.mainlandEmail)
        );
        if (
          drivers.filter((item) => item.mainlandPhone || item.mainlandEmail)
            .length == drivers.length
        ) {
          this.driversRules.mainlandEmail[0].required = false;
          this.driversRules.mainlandPhone[0].required = false;
        }
        // for(let item in drivers){
        //   let mainlandPhone = drivers[i].mainlandPhone;
        //   let mainlandEmail = drivers[i].mainlandEmail;
        //   if(!mainlandPhone && !mainlandEmail){

        //   }
        // }
        this.$refs["ruleForm"][i].validate((valid) => {
          if (!valid) flag = false;
        });
      }
      return flag;
    },

    // 應用車主信息
    setDrivers(index, watch = false, first = false) {
      // console.log("setDriversIndex:", index);
      // 填入車主資料到選擇的駕駛人中
      const inputDrivers = (index, input) => {
        const form = this.form;
        const quota = form.quota;
        // const form = JSON.parse(JSON.stringify(this.form));
        // const quota = JSON.parse(JSON.stringify(this.form.quota));
        let driver = {};
        driver.nameCn = input ? quota.personNameCn || null : null;
        driver.nameEn = input ? quota.personNameEn || null : null;
        driver.identityNo = input ? quota.personIdentityNo || null : null;
        driver.birthday = input ? quota.personBirthday || null : null;
        driver.macauAddress = input
          ? quota.macauAddress
          : { textCn: "", textPt: "" };
        driver.macauMobile = input ? quota.macauMobile || null : null;
        driver.mainlandPhone = input ? quota.mainlandPhone || null : null;
        driver.mainlandEmail = input ? quota.mainlandEmail || null : null;
        // 年齡70以下時，去掉內地駕照欄位
        const age = this.ageCalculation(form.drivers[index].birthday);
        if (age < 70) {
          driver.mainlandDrivingLicenseNo = null;
          driver.mainlandDrivingPermitNo = null;
        }
        form.drivers[index] = { ...form.drivers[index], ...driver };
        // this.$store.commit("updateForm", form);
        // this.$set(this.form, "drivers", form.drivers);
        this.$set(this.form.drivers, 0, {
          ...this.form.drivers[index],
          ...driver,
        });
        // 處理nameEn驗證異步
        if (form.quota.personNameEn) {
          const _fields = this.locked
            ? this.$refs["ruleForm"][this.locked - 1].fields
            : null;
          // console.log(_fields);
          if (_fields) {
            _fields.map((i) => {
              if (i.prop === "nameEn") {
                i.resetField();
                return false;
              }
            });
          }
        }
      };
      // 切換到無
      if (index == 0 && !first) {
        this.$confirm(
          `${this.$t(
            "message.DataRegistration.Driver.change_drivers_tips1"
          )}${this.$t(`message.capitalLetter[${this.locked}]`)}${this.$t(
            "message.DataRegistration.Driver.change_drivers_tips2"
          )}`,
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            const form = this.form;
            // const form = JSON.parse(JSON.stringify(this.form));
            // form.drivers[this.locked - 1] = {
            //   macauAddress: {
            //     textCn: "",
            //     textPt: "",
            //   },
            // };
            this.$set(this.form.drivers, this.locked - 1, {
              macauAddress: {
                textCn: "",
                textPt: "",
              },
            });
            this.$store.commit("updateForm", form);
            this.$refs["ruleForm"][this.locked - 1].resetFields();
            this.locked = index;
          })
          .catch(() => {
            this.setDriver = this.setDriverOld;
            this.locked = this.setDriverOld;
          });
        return false;
      }
      if (watch) {
        inputDrivers(index - 1, true);
        return;
      } else {
        if (this.locked && index >= 0) {
          // 刪除上一個駕駛人資料
          this.$confirm(
            `${this.$t(
              "message.DataRegistration.Driver.change_drivers_tips1"
            )}${this.$t(`message.capitalLetter[${this.locked}]`)}${this.$t(
              "message.DataRegistration.Driver.change_drivers_tips2"
            )}`,
            this.$t("message.tips"),
            {
              confirmButtonText: this.$t("message.confirm"),
              cancelButtonText: this.$t("message.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              const quota = this.form.quota;
              // 駕駛人資料互換後，清空上一個表單
              let drivers = this.form.drivers;
              // let drivers = JSON.parse(JSON.stringify(this.form.drivers));
              this.form.drivers[index - 1] = drivers[this.locked - 1];
              this.form.drivers[this.locked - 1] = {
                macauAddress: {
                  textCn: "",
                  textPt: "",
                },
              };
              // 將車主信息資料應用到駕駛人
              inputDrivers(index - 1, true);
              inputDrivers(this.locked - 1, false);
              this.$refs["ruleForm"][this.locked - 1].resetFields();
              this.locked = index;
            })
            .catch(() => {
              this.setDriver = this.setDriverOld;
            });
        } else {
          if (!first) {
            this.$confirm(
              `${this.$t(
                "message.DataRegistration.Driver.change_drivers_tips1"
              )}${this.$t(`message.capitalLetter[${this.locked}]`)}${this.$t(
                "message.DataRegistration.Driver.change_drivers_tips2"
              )}`,
              this.$t("message.tips"),
              {
                confirmButtonText: this.$t("message.confirm"),
                cancelButtonText: this.$t("message.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                inputDrivers(index - 1, true);
                this.locked = index;
              })
              .catch(() => {
                this.setDriver = this.setDriverOld;
                this.locked = this.setDriverOld;
              });
          } else {
            inputDrivers(index - 1, true);
            this.locked = index;
          }
        }
      }
    },
    quotaChange(index) {
      // console.log(index);
      this.setDrivers(index);
    },
    // 打開澳門地址填寫彈窗
    onAddressFocus(index) {
      // console.log(index);
      this.macauAddressIndex = index;
      this.showAddressDialog = true;
    },
    // 儲存澳門地址回調
    saveMacauAddress(val) {
      // console.log(val);
      this.showAddressDialog = false;
      this.form.drivers[this.macauAddressIndex].macauAddress = { ...val };
    },
    // 修改國籍
    changeNationality(val, index) {
      // console.log(val);
      this.form.drivers[index].otherNationality = val == "XXX" ? true : false;
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, index, name) {
      this.form.drivers[index][name] = val.toUpperCase();
    },
    changeBirthday(val, index) {
      const age = this.ageCalculation(val);
      if (age < 70) {
        this.$set(this.form.drivers[index], "mainlandDrivingLicenseNo", null);
        this.$set(this.form.drivers[index], "mainlandDrivingPermitNo", null);
      }
    },
  },
  created() {
    // 獲取國籍數據
    this.loading = true;
    Promise.all([
      VssViewAPI.getNationalitys(),
      VssViewAPI.getDrivingLicenseTypes(),
      VssViewAPI.getsexs(),
    ])
      .then((res) => {
        this.loading = false;
        this.nationality = res[0];
        // {
        //     codeCname: "其他",
        //     codeKey: "OTHER",
        //     codeMasterCname: "國籍",
        //     codeMasterPname: "other",
        //     codeMasterType: 0,
        //     codeOrder: 1,
        //     codePname: "其他",
        //     codeStatus: "A"
        // }
        this.drivingLicenseType = res[1];
        this.sex = res[2];
      })
      .catch((err) => {
        this.loading = false;
        this.$error(err);
        // console.log(err);
      });

    if (
      this.$store.state.serviceType == "HZMB_FIRST_PERSON" ||
      this.$store.state.serviceType == "HZMB_RENEW_PERSON"
    ) {
      if (this.applicationType == "FIRST") {
        this.setDriver = 1;
        this.setDrivers(1, false, true);
      } else {
        this.setDriver = 0;
        this.setDrivers(0, false, true);
      }
    }
    if (this.applicationType == "RENEW") {
      this.driversRules.mainlandDrivingLicenseNo = [
        { required: true, message: this.$t("message.formRuleMessage.notNull") },
      ];
      this.driversRules.mainlandDrivingPermitNo = [
        { required: true, message: this.$t("message.formRuleMessage.notNull") },
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.input_choose_title {
  margin: 16px 0;
  font-size: 18px;
}
.input_choose_btns {
  /deep/.el-radio {
    background: #fff;
    margin-right: 10px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.warn-icon {
  font-size: 18px;
  line-height: 38px;
  margin-left: 6px;
  cursor: pointer;
}
</style>
